<template>
  <div v-if="activeCountryId" class="right-widgets__wrapper" :class="open ? 'open' : ''">
    <div class="widget-toggle__wrapper">
      <v-btn icon dark class="btn toggle__btn" @click="open = !open">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn icon dark class="btn" @click="clearActiveCountry">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <CountryInfo :open="open" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import CountryInfo from 'Components/CountryInfo';

export default {
  name: 'RightWidgetsContainer',
  components: { CountryInfo },
  data: () => {
    return {
      open: true
    };
  },
  computed: {
    ...mapGetters({
      activeCountryId: 'mapStore/getActiveCountryId'
    })
  },
  methods: {
    ...mapMutations({
      setActiveCountryId: 'mapStore/setActiveCountryId'
    }),
    clearActiveCountry() {
      this.setActiveCountryId(null);
    }
  }
};
</script>

<style lang="scss" scoped>
.right-widgets__wrapper {
  pointer-events: none;
  position: absolute;
  right: 1em;
  top: 33%;
  overflow: hidden;
  padding: 40px 1em 1em 1em;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.2);

  .widget-toggle__wrapper {
    width: 100%;
    padding: 0 24px 0 8px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    .btn {
      pointer-events: all;
    }
  }

  &.open {
    .widget-toggle__wrapper {
      .toggle__btn {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
